import productImg11 from '../assets/newManufacturing/productImg11.png';
import productImg12 from '../assets/newManufacturing/productImg12.png';
import productImg13 from '../assets/newManufacturing/productImg13.png';
import priceImg11 from '../assets/newManufacturing/pricingImg11.png';
import priceImg12 from '../assets/newManufacturing/pricingImg12.png';


export default [
    {
        title: "PCB Manufacturing",
        description: '	We manufacture quality Printed Circuit Boards in both mass quantity and low quantity. Our PCB specification if given below: ',
        features: [
            {
                name: 'Design rule standards: ',
                value: [
                    `Layer: 	Single and double layer`,
                    `Through Hole Plating:  No`,
                    `Maximum size: A4 (210mm x 297mm)`,
                    `Board material: FR4 ZD fiber, ZD red, and glass fiber`,
                    `Copper thickness: 1oz`,
                    `Minimum trace width: 	15mill (0.381mm)`,
                    `Min trace to trace gap: 15mill (0.381mm)`,
                    `Min drill diameter: 	0.5mm`,
                    `Outline cutting: 	Supports splines (Gerber needed)`,
                    `Drill alignment tolerance: +-0.2mm`,
                    `Board finish: 		HASL, Rosin based`,
                    `Masking type: 		Heat proof, normal`,
                    `Top/bottom silk: 	Heat proof, normal`,
                ]
            },
            {
                name: 'Filetype:',
                value: [
                    `PDF (for no spline outline support and accurate drilling)`,
                    `Gerber (For accurate output)`
                ]
            }
        ],
        pricing: [
            {
                name: 'Single Layer PCB',
                image: priceImg11,
                price: '5',
                unit: '/Square inch',
                buildTime: 'Build Time: 1 Day',
                data: [
                    (<span>Processing charge : 200 tk</span>),
                    (<span>Silk Screen Printing</span>),
                    (<span>CNC Drilling</span>),
                    (<span>Surface finish available</span>),
                    (<span>Masking type:Heat proof, normal</span>),
                ]
            },
            {
                name: 'Double Layer PCB ',
                image: priceImg12,
                price: '8',
                unit: '/Square inch',
                buildTime: 'Build Time: 1 Day',
                data: [
                    (<span>Processing charge : 200 tk</span>),
                    (<span>Plated Through Hole (coming soon)</span>),
                    (<span>Masking, Silk Screen Printing, CNC Drilling,</span>),
                    (<span>Surface finish available</span>)
                ]
            }
        ],
        notice: 'Pricing may vary depending on PCB quantity and specification. All pricing based on a maximum drill count of 10 per square inch. ',
        pricingCapabilites: [],
        products: [
            {
                name: 'Item 1',
                image: productImg11,
                subheading: 'Subheading'
            },
            {
                name: 'Item 1',
                image: productImg12,
                subheading: 'Subheading'
            },
            {
                name: 'Item 1',
                image: productImg13,
                subheading: 'Subheading'
            }
        ]
    }
]